const LEAGUE_BG_PALETTE = [
  "#cc9900",
  "#9e9400",
  "#663345",
  "#098000",
  "#3300CC",
  "#9DA8A0",
  "#00CCCC",
  "#847a80",
  "#1ba578",
  "#ec8535",
];

export function formatValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  return value;
}

export function pickStableLeagueBg(seed) {
  const s = String(seed ?? "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return LEAGUE_BG_PALETTE[h % LEAGUE_BG_PALETTE.length];
}

export function makeLeagueShortName(name) {
  if (!name) return "";
  const words = String(name)
    .trim()
    .toUpperCase()
    .split(/\s+/)
    .filter(Boolean);

  if (words.length >= 2) {
    return `${words[0].slice(0, 3)} ${words[1].slice(0, 3)}`;
  }
  if (words[0]?.length >= 6) {
    return `${words[0].slice(0, 3)} ${words[0].slice(3, 6)}`;
  }
  return words[0] || "";
}

